<template>
    <MdField :class="{ 'bordered': outlined, 'md-invalid': showError }" :style="grid ? `grid-area: ${name}` : ''">
        <label>{{ label }}</label>
        <MdTextarea
            :name="name"
            :value="input.value"
            @input="$emit('update', { value: $event, error: getError($event) })"
        />
        <span v-if="counter && !!length" :class="{ 'counter': true, 'warning': showWarning }">
            {{ input.value ? input.value.length : 0 }} | {{ length }}
        </span>
        <span class="md-error" v-show="showError">{{ showError }}</span>
    </MdField>
</template>

<script>
export default {
  name: 'IoTextarea',
  model: {
    prop: 'input',
    event: 'update',
  },
  props: {
    input: {
      type: Object,
      default: () => ({}),
    },
    label: {
      required: true,
      type: String,
    },
    counter: {
      type: Boolean,
      default: true,
    },
    length: {
      type: Number,
      default: 0,
    },
    name: {
      required: true,
      type: String,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    grid: {
      type: Boolean,
      default: false,
    },
    // error: {
    // 	type: String,
    // 	default: ''
    // },
  },
  methods: {
    getError(payload) {
      if (!(this.counter && !!this.length)) {
        return '';
      }

      const lengthCheck = payload ? payload.length > this.length : false;
      return lengthCheck ? 'Your text contains more characters than allowed' : '';
    },
  },
  computed: {
    showWarning() {
      return this.input.value ? this.input.value.length > this.length : false;
    },
    showError() {
      return this.input.error ? this.input.error : '';
    },
  },
};
</script>

<style lang="scss" scoped>
$secondary-color: #dee2e6;

.bordered {
    border: 1px solid $secondary-color;
    border-radius: 5px;
}

.counter {
    position: absolute;
    bottom: 0;
    right: 0.5rem;
    pointer-events: none;

    &.warning {
        color: #dc3545;
    }
}

.md-field .md-error {
    background-color: #fffc;
}
</style>
